import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=463c74a2&"
import script from "./Step.vue?vue&type=script&lang=ts&"
export * from "./Step.vue?vue&type=script&lang=ts&"
import style0 from "./Step.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports